<script setup lang="ts">
const isOpen = defineModel<boolean>('open', { default: false })
const target = ref<HTMLElement | null>(null)

const close = () => {
  isOpen.value = false
}

onClickOutside(target, close)

watch(isOpen, (value) => {
  document.documentElement.classList.toggle('page-is-frozen', value)
})

onBeforeUnmount(() => document.documentElement.classList.remove('page-is-frozen'))
</script>

<template>
  <Teleport to="body">
    <div v-if="isOpen" ref="target" class="modal">
      <div class="background" @click="close" />

      <button class="close" type="button" @click="close">
        <Icon name="large-close" />
      </button>

      <div class="content">
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  overflow-y: auto;
  z-index: 102;
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.15);
}

.close {
  position: absolute;
  top: 38px;
  right: 31px;
  z-index: 1;

  @include breakpoint(ts) {
    top: 40px;
    right: 40px;
  }

  svg {
    color: var(--c-blue-100);
    width: 18px;
    height: 18px;

    @include breakpoint(ts) {
      width: 24px;
      height: 24px;
    }
  }
}

.content {
  width: 100%;
  float: right;
  padding: 60px 40px;
  overflow-y: auto;
  min-height: 100vh;
  max-width: 800px;
  padding-top: 94px;

  position: relative;
  background-color: var(--c-white);

  box-shadow: var(--shadow);

  @include breakpoint(ds) {
    padding-block: 120px;
    width: 50%;
  }
}
</style>
